import { belowBreakpointOrEqual, getColor, lightenColor, styled } from "imaginarity-react-ui";

export class RangeSliderSC {
  public static Container = styled.div<{ rangeBarColor?: string, hideValues?: boolean, sliderBackground?: string, trackColor?: string, marginBottom?: number, labelSize?: string }>`
    margin-top: 10px;
    margin-bottom: ${p => p.marginBottom ?? 0}px;
    width: calc(100% - 2em);
    margin-left: 1em;
    text-align: center;
    .input-range__slider {
      border-radius: 100%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2rem;
      width: 2rem;
      margin-left: -1rem;
      margin-top: -1rem;
      outline: none;
      position: absolute;
      top: -1px;
      transition: left 200ms ease-out;
      will-change: left;

      &::before {
        content: "";
        background: ${p => p.sliderBackground ? getColor(p, p.sliderBackground) : lightenColor(p, p.theme.backgroundColor, 40)};
        border-radius: ${p => belowBreakpointOrEqual(p, "tablet") ? 11 : 3}px;
        display: block;
        height: 21px;
        width: ${p => belowBreakpointOrEqual(p, "tablet") ? 21 : 3}px;
        transition: transform 200ms ease-out, box-shadow 200ms ease-out;
        will-change: transform, box-shadow;
      }
      &:hover::before {
        background: ${(p) => lightenColor(p, p.theme.colors.accent, 100)};
        border-radius: ${p => belowBreakpointOrEqual(p, "tablet") ? 11 : 3}px;
        transform: ${p => belowBreakpointOrEqual(p, "tablet") ? "scale(1.5)" : "scaleY(1.5)"};
      }
      &:active::before {
        background: ${(p) => lightenColor(p, p.theme.colors.accent, 100)};
        border-radius: ${p => belowBreakpointOrEqual(p, "tablet") ? 11 : 3}px;
        transform: ${p => belowBreakpointOrEqual(p, "tablet") ? "scale(1.5)" : "scaleY(2)"};
      }
      .input-range--disabled &::before {
        background: ${(p) => getColor(p, "@middleLightGrey")};
        border: ${(p) => getColor(p, "@middleLightGrey")};
        box-shadow: none;
        transform: none;
      }
    }

    .input-range__label-container {
      display: ${(p) => (p.hideValues ? "none" : "block")};
      position: absolute;
      width: 200px;
      height: 1em;
      line-height: 1em;
      font-size: ${p => p.labelSize ?? "0.8em"};
      top: 1.2em;
      left: 50%;
      transform: translateX(-50%);
    }

    .input-range__label--min {
      display: none;
    }
    .input-range__label--max {
      display: none;
    }

    .input-range__track {
      background: ${(p) => p.trackColor ? getColor(p, p.trackColor) : lightenColor(p, p.theme.backgroundColor, 80)};
      border-radius: 2px;
      cursor: pointer;
      display: block;
      height: 3px;
      position: relative;
      transition: left 200ms ease-out, width 200ms ease-out;
      will-change: left, width;

      .input-range--disabled & {
        background: ${(p) => lightenColor(p, p.theme.backgroundColor, 80)};
      }
    }

    .input-range__track--background {
      margin-top: 0;
      top: 50%;
      position: absolute;
      left: 0;
      right: 0;
    }

    .input-range__track--active {
      background: ${(p) => getColor(p, p.rangeBarColor ?? "@accent")};
    }

    .input-range {
      height: 1rem;
      position: relative;
      width: 100%;
    }
  `;
}
